<div *ngIf="loading">
  <app-loading message="Consolidando pago por NotMenu"></app-loading>
</div>
